import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { fetchUserProfile } from '@/services/profile';

export default function AuthGuard({ children, requireAdmin = false }: {
  children: React.ReactNode;
  requireAdmin?: boolean;
}) {
  const { user, loading } = useAuth();
  const [roleAllowed, setRoleAllowed] = useState<boolean | null>(requireAdmin ? null : true);

  useEffect(() => {
    if (!requireAdmin || !user) return;
    let mounted = true;
    fetchUserProfile().then((profile) => {
      if (mounted) setRoleAllowed(profile?.role === 'admin' || profile?.role === 'super_admin');
    });
    return () => { mounted = false; };
  }, [requireAdmin, user]);

  if (loading || (user && requireAdmin && roleAllowed === null)) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-3 border-primary-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-foreground-600 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !roleAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}